module.exports = __webpack_public_path__ + "src/components/Footer/playStore.png?04aeef06";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/playStore.png
// module id = 3094
// module chunks = 8